
async function fetchAsync (url) {
    try {
        const response = await fetch(url);
        return await response.json();
    } catch (e) {
        alert('Something went wrong: ' + e);
    }
}

export async function getCatalogProducts(appVersion){

    /*
        Produits formats:       Table element_format_desc
        Produits logistique :   API refonte
        Autres produits :       API refonte
     */

    // Get logistic + base products
    let base = 'https://api.for-ever.com/v3/websites/';
    let endPointProduct = base+'upsale.for-ever.com/products';
    if(appVersion == 'A3'){
        endPointProduct = 'https://api.for-ever.com/v3/websites/upsaleplus.for-ever.com/products';
    }else if(appVersion == 'A2'){
        endPointProduct = 'https://api.for-ever.com/v3/websites/upsalepro.for-ever.com/products';
    }
    return fetchAsync (endPointProduct).then((data) => {
        let products = data._embedded.products;
        let restitutionProducts = [];
        let logisticProducts = [];
        let restitutionProductsRefs = [];
        let logisticProductsRefs = [];
        let orderFeeProduct;
        products.forEach(product => {
            if (product.hasOwnProperty('categories')) {
                for (const [key, value] of Object.entries(product.categories)) {
                    if(value.reference=='output'){
                        restitutionProducts.push(product);
                        restitutionProductsRefs.push(product.reference);
                    }
                    else if(value.reference=='logistic'){
                        logisticProducts.push(product);
                        logisticProductsRefs.push(product.reference);
                    }
                    else if(value.reference=='base'){
                        orderFeeProduct = product;
                    }
                    break;
                }
            }
        });
        return {
            'restitutionProducts' : {'products' : restitutionProducts, 'refs' : restitutionProductsRefs},
            'logisticProducts' : {'products' : logisticProducts, 'refs' : logisticProductsRefs},
            'orderFeeProduct' : orderFeeProduct
        }
    });
}

export function getRestitutionProduct(context, ref){ // check if the product exists for this app
    return context.catalog.restitutionProducts.products.filter(r => r.reference == ref)[0];
}
export function getRestitutionProductsDisplayed(total_elements_size, context, def, large_file = false){

    let displayed_products = [];
    if (!large_file) {
        let dl = getRestitutionProduct(context, "output_dematerialized_download");
        if (dl && total_elements_size <= def.max_order_size_download_link) {
            displayed_products.push(dl);
        }
    }
    let key_16, key_32, key_64, key_128;
    let p = {};
    if(total_elements_size < 16){
        key_16 = getRestitutionProduct(context, "output_physical_usb_key_16");
        if(key_16){p = key_16;}
    } else if (total_elements_size >= 16 && total_elements_size < 32) {
        key_32 = getRestitutionProduct(context, "output_physical_usb_key_32");
        if(key_32){p = key_32;}
    } else if (total_elements_size >= 32 && total_elements_size < 64) {
        key_64 = getRestitutionProduct(context, "output_physical_usb_key_64");
        if(key_64){p = key_64;}
    } else if (total_elements_size >= 64 && total_elements_size < 128) {
        key_128 = getRestitutionProduct(context, "output_physical_usb_key_128");
        if(key_128){p = key_128;}
    }
    if(key_16 || key_32 || key_64 || key_128){
        displayed_products.push(p);
    }
    if(total_elements_size < 1024){
        let disk = getRestitutionProduct(context, "output_physical_hard_disk");
        if(disk){
            displayed_products.push(disk);
        }
    } else {
        let disk2 = getRestitutionProduct(context, "output_physical_hard_disk_2");
        if(disk2){
            displayed_products.push(disk2);
        }
    }
    //unique list of products
    const displayed_products_unique = [...new Map(displayed_products.map(item => [item['reference'], item])).values()];

    return displayed_products_unique;
}

export function getLogisticProductName(product) {
    if(product.reference == 'logistic_colissimo'){return "Transporteur Colissimo";}
    else if (product.reference == 'logistic_ups'){return "Transporteur UPS";}
    else if (product.reference == 'logistic_gls'){return "Transporteur GLS";}
    else if (product.reference == 'logistic_tracked'){return "Colis suivi";}
    else{return product.label;}
}

export function getFormat(context, formatId) {
    let formatsCatalog = context.catalog.formats;
    let format;
    Object.keys(formatsCatalog).forEach(family => {
        Object.keys(formatsCatalog[family]).forEach(format_id => {
            if(formatsCatalog[family][format_id]['format_id'] == formatId){
                let f = formatsCatalog[family][format_id];
                format = getFormatResolutionFullname(f['resolution']) + ' (' + getOrderElementsTitle(f['family']) + ')';
            }
        });
    });
    return format;
}

export function getOrderElementsTitle(orderFamily) {
    if(orderFamily == 'tape'){
        return 'cassette(s)';
    }else if(orderFamily == 'mixte'){
        return 'film(s) et cassette(s)';
    }else{
        return 'film(s)';
    }
}

export function getFormatResolutionFullname(resolution){
    if(resolution=='SD') {
        return 'Qualité standard';
    }else if(resolution=='HD'){
        return 'Qualité Full HD';
    }else if(resolution=='4k'){
        return 'Qualité 4K';
    }
}
